import React, { useEffect } from "react";
import Banner from "../components/trading/Banner";
import StatsBlock from "../components/trading/StatsBlock";
import ExecutionControl from "../components/trading/ExecutionControl";
import LowerCosts from "../components/trading/LowerCosts";
import OneAccount from "../components/trading/OneAccount";
import PlatformAccess from "../components/trading/PlatformAccess";
import Details from "../components/trading/Details";
import Faq from "../components/trading/Faq";
import CTASection from "../components/trading/CTASection";

function Trading() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <StatsBlock />
      <ExecutionControl />
      <LowerCosts />
      <OneAccount />
      <PlatformAccess />
      <Details />
      <Faq />
      <CTASection />
    </div>
  );
}

export default Trading;
